import { action } from 'mobx';
import { OrderService, HistoryLogService, SplitOrderService } from 'common/data';
import _ from 'lodash';
import { BaseStore } from 'core/stores';

class OrderStore extends BaseStore {
	constructor(rootStore) {
		super(new OrderService(rootStore.app.baasic.apiClient));
		this.historyLogService = new HistoryLogService(rootStore.app.baasic.apiClient);
		this.splitOrderService = new SplitOrderService(rootStore.app.baasic.apiClient);
	}

	@action
	findOrder = async filter => {
		const response = await this.service.find(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
		return response.data;
	};

	@action
	replace = async (replaceParams, sourceOfChange) => {
		await this.service.replace(replaceParams, sourceOfChange);
	};

	@action
	async updateOrder(order, sourceOfChange) {
		await this.service.update(order, sourceOfChange);
	}

	@action
	async createOrder(order, sourceOfChange) {
		const response = await this.service.create(order, sourceOfChange);
		this.item = response;
		return this.item.data;
	}

	@action
	async createOrdersBulk(orders, sourceOfChange) {
		const response = await this.service.createOrdersBulk(orders, sourceOfChange);
		this.item = response;
		return this.item.data;
	}

	@action
	findMarketplaceOrderHistoryLog = async filter => {
		const response = await this.historyLogService.find(filter);
		_.each(response.data.item, responseItem => {
			responseItem.changed = JSON.parse(responseItem.changed);
		});
		this.response = response.data;
	};

	@action
	getOrder = async (id, options) => {
		const response = await this.service.get(id, options);
		this.item = response.data;
		return response.data;
	};

	@action
	splitMarketplaceOrder = async (orderId, sourceOfChange) => {
		var response = await this.splitOrderService.splitOrderAsync(orderId, sourceOfChange);
		return response.data;
	};

	@action
	validateOrderAddress = async order => {
		var response = await this.service.validateOrderAddress(order);
		this.item = response.data;
		return response.data;
	};

	@action
	async updateOrderInfo(order, sourceOfChange) {
		const response = await this.service.updateOrderInfo(order, sourceOfChange);
		this.item = response;
		return this.item.data;
	}
}

export default OrderStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/OrderStore.js